import { render, staticRenderFns } from "./FaceDeviceV3Manage.vue?vue&type=template&id=182de238&scoped=true&"
import script from "./FaceDeviceV3Manage.vue?vue&type=script&lang=js&"
export * from "./FaceDeviceV3Manage.vue?vue&type=script&lang=js&"
import style0 from "./FaceDeviceV3Manage.vue?vue&type=style&index=0&id=182de238&scoped=true&lang=css&"
import style1 from "./FaceDeviceV3Manage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182de238",
  null
  
)

export default component.exports